
export const colors = [
    {
        id: 1,
        hexCode: '#9e9e9e',
        name: 'Black',
        icon: '⚫',
    },
    {
        id: 2,
        hexCode: '#b0c5f9',
        name: 'Blue',
        icon: '🔵',
    },
    {
        id: 3,
        hexCode: '#bfe6a1',
        name: 'Green',
        icon: '🟢',
    },
    {
        id: 4,
        hexCode: '#b39efb',
        name: 'Purple',
        icon: '🟣',
    },
    {
        id: 5,
        hexCode: '#ffc773',
        name: 'Orange',
        icon: '🟠',
    },
    {
        id: 6,
        hexCode: '#f7e181',
        name: 'Yellow',
        icon: '🟡',
    },
    {
        id: 7,
        hexCode: '#a9684e',
        name: 'Brown',
        icon: '🟤',
    },
]